export class UnexpectedError extends Error {}
